import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsKY: CultureInfo = {
  name: 'es-KY',
  displayName: 'español (Islas Caimán)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-KY',
  parent: CultureInfoEs
};
